import { Typography } from "@mui/material";
import { Box, FlexColBox } from "../../../../common/components";
import { palette, spacing } from "../../../../styles/theme";
import { ComboItems } from "../../../../types";
import { ItemPricing } from "../../../../types";
import { useCurrency } from "../../../../common/hooks/useCurrency";
import { useSelector } from "../../../../common/hooks/useSelector";
import CartItemWarnings from "../../Components/CartItemWarnings";

interface Props {
  deprecatedDesign: boolean;
  item: ItemPricing;
  comboItems: ComboItems;
}

const CartItemPreviewPricingInfo = ({
  deprecatedDesign,
  item,
  comboItems,
}: Props) => {
  const { aboveMinimumQuantity, belowMaximumQuantity, quantity } = comboItems;
  const { distributor: distributorPrices } = item;
  const { NarrowCurrencyFormatter } = useCurrency();
  const { showDistributorPrices } = useSelector((state) => state.cart);

  return (
    <FlexColBox
      gap={{ xs: spacing.xxsMobile, lg: spacing.xxsDesktop }}
      height={"fit-content"}
    >
      {!deprecatedDesign && aboveMinimumQuantity && belowMaximumQuantity && (
        <Box display={"flex"} alignItems={"center"}>
          <Typography
            variant="textSm"
            color={palette.grey.primary}
          >{`${quantity} x`}</Typography>
          <Typography variant="textSm" color={palette.grey.primary}>
            &nbsp;
            {`${NarrowCurrencyFormatter?.format(
              showDistributorPrices && !!distributorPrices
                ? distributorPrices.pricePerUnit
                : item.pricePerUnit
            )}`}
          </Typography>
        </Box>
      )}
      <CartItemWarnings
        deprecatedDesign={deprecatedDesign}
        item={item}
        comboItems={comboItems}
        hideEndOfLifeWarning={true}
      />
    </FlexColBox>
  );
};

export default CartItemPreviewPricingInfo;
